/**
 * Domain-aware cookie helpers for portal (apps/app).
 *
 * Cookies are scoped to `.pontimed.app` (or `.pontimed.local` in dev) so they
 * survive cross-subdomain navigation between marketing (apps/web) and portal
 * (apps/app) without re-prompting the user.
 *
 * Extracted from src/i18n/i18n.ts so country state + locale state share the
 * same writer and the regex stays in one place.
 */

const ROOT_DOMAIN_REGEX = /(?:^|\.)pontimed\.([a-z]+)$/i;

function getCookieDomainSuffix(): string {
  if (typeof location === "undefined") return "";
  const m = location.hostname.match(ROOT_DOMAIN_REGEX);
  return m ? `; Domain=.pontimed.${m[1]}` : "";
}

export function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function writeCookie(name: string, value: string, days = 365): void {
  if (typeof document === "undefined") return;
  const expires = new Date(Date.now() + days * 86_400_000).toUTCString();
  const isHttps = location.protocol === "https:";
  const domain = getCookieDomainSuffix();
  const secure = isHttps ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Expires=${expires}; SameSite=Lax${secure}${domain}`;
}

export function deleteCookie(name: string): void {
  if (typeof document === "undefined") return;
  const domain = getCookieDomainSuffix();
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT${domain}`;
}
